import AnchorLink from './AnchorLink';

const VARIANTS = {
  accent: 'bg-accent text-bg hover:bg-accent-600',
  'accent-hero': 'bg-accent text-bg hover:bg-accent-400',
  ink: 'bg-ink text-bg hover:bg-accent',
  'outline-light': 'border-2 border-bg text-bg hover:bg-bg hover:text-ink',
  'outline-ink': 'border-2 border-ink text-ink hover:bg-ink hover:text-bg',
};

const SIZES = {
  44: 'h-11 px-[18px] text-[15px]',
  48: 'h-12 px-[18px] text-[15px]',
  52: 'h-btn-sm px-[18px] text-[15px]',
  58: 'h-btn px-5 text-[16px]',
  60: 'h-btn-lg px-5 text-[17px]',
};

/**
 * Flat, square button. `spread` puts the label left and the arrow right.
 * Renders an anchor when `href` is given, a <button> otherwise.
 */
export default function Button({ href, variant = 'accent', size = 58, spread = false, arrow = true, className = '', children, ...rest }) {
  const cls = `inline-flex items-center font-extrabold transition-colors duration-150 ${spread ? 'justify-between gap-7' : 'gap-2.5'} ${VARIANTS[variant]} ${SIZES[size]} ${className}`;
  const inner = (
    <>
      {spread ? <span>{children}</span> : children}
      {arrow && <span aria-hidden="true">→</span>}
    </>
  );
  if (href) return <AnchorLink href={href} className={cls} {...rest}>{inner}</AnchorLink>;
  return <button type="button" className={cls} {...rest}>{inner}</button>;
}
